export default __webpack_public_path__ + "img/a0ed4b7bd3946e8ce8e1f962642a9e18.png";